import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";

  interface Props {
    modelValue: string;
    inputClasses: string | string[];
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'InputPassword',
  props: {
    modelValue: {},
    inputClasses: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  

  const showPassword = ref(false);
  const pathEye = computed(() =>
    require(`@/assets/icons/icon-eye${showPassword.value ? "-active" : ""}.svg`)
  );

const __returned__ = { showPassword, pathEye, computed, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})